module.exports = __webpack_public_path__ + "static/img/pbc.d3afc95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reserva/pbc.jpg
// module id = jg64
// module chunks = 1